import { ActivityConfig } from '@/types/integrations.types';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';
import { ChangeEvent } from 'react';

interface ActivityIntegrationCardProps {
  activity: ActivityConfig;
  setConfig?: (config: ActivityConfig) => void;
  disabled?: boolean;
}

export default function ActivityIntegrationCard({
  activity,
  setConfig,
  disabled = false,
}: ActivityIntegrationCardProps) {
  const handleActivityIdChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (setConfig) {
      const value = parseInt(e.target.value);
      setConfig({
        ...activity,
        activityTypeId: value,
        enabled: !isNaN(value),
      });
    }
  };

  return (
    <div className="activity-card-container">
      <div className="activity-card">
        <div className="activity-data">
          <span className="activity-label">{activity.label}</span>
          <InputWithOverlay
            wrapperClass="activity-id-input"
            inputProps={{
              onChange: handleActivityIdChange,
              defaultValue: activity.activityTypeId?.toString(),
              placeholder: 'Enter activity ID',
              disabled,
              type: 'number',
            }}
          />
        </div>
      </div>
    </div>
  );
}
